import type React from 'react'

import { SkeletonBlock, SkeletonButtonRow, SkeletonField } from '@/components/framework'

interface ChecklistFormSkeletonProps {
  loadingLabel: string
}

export const ChecklistFormSkeleton: React.FC<ChecklistFormSkeletonProps> = ({ loadingLabel }) => (
  <div className="space-y-6" aria-busy="true" role="status">
    <span className="sr-only">{loadingLabel}</span>

    <div className="rounded border border-gray-200 bg-gray-50 p-4" aria-hidden="true">
      <SkeletonBlock className="mb-4 h-4 w-32" />
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <SkeletonField />
        <SkeletonField />
      </div>
    </div>

    <div className="rounded border border-gray-200 bg-white p-4" aria-hidden="true">
      <SkeletonBlock className="mb-4 h-4 w-40" />
      <div className="space-y-5">
        <SkeletonField />
        <div className="space-y-2">
          <SkeletonBlock className="h-4 w-48" />
          <div className="flex flex-wrap gap-4">
            <SkeletonBlock className="h-4 w-20" />
            <SkeletonBlock className="h-4 w-20" />
            <SkeletonBlock className="h-4 w-20" />
          </div>
        </div>
        <SkeletonField />
        <SkeletonField />
      </div>
    </div>

    <SkeletonButtonRow />
  </div>
)
